import { useState, useRef, useEffect } from 'react';
import { useAIChat, LANGUAGES } from '../hooks/useAI';

const QUICK = [
  'Translate "Hello, how are you?" to Swahili, Yoruba and Luganda',
  'Write a caption for an Afrobeats video post',
  'Translate "I love Uganda" to Luganda',
  'What are trending topics in Africa right now?',
  'Help me write a post for Ugandan Independence Day',
];

export default function AIPage() {
  const { messages, loading, sendMessage } = useAIChat();
  const [input, setInput] = useState('');
  const bottomRef = useRef(null);
  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior:'smooth' }); }, [messages, loading]);

  async function handleSend(text) {
    const t = text || input; if (!t.trim()) return;
    setInput(''); await sendMessage(t);
  }
  function handleKey(e) { if (e.key==='Enter' && !e.shiftKey) { e.preventDefault(); handleSend(); } }

  return (
    <div style={{ display:'flex', flexDirection:'column', flex:1, height:'100%', overflow:'hidden' }}>
      <div style={{ padding:'16px 20px 12px', borderBottom:'1px solid var(--border)', background:'var(--earth)', flexShrink:0 }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <h2 style={{ fontFamily:'Sora,sans-serif', fontSize:18, fontWeight:600, color:'var(--text)' }}>Umoja AI</h2>
          <span style={{ fontSize:11, background:'linear-gradient(135deg, var(--sunset), var(--flame))', color:'white', padding:'2px 8px', borderRadius:20 }}>BETA</span>
        </div>
        <p style={{ fontSize:12, color:'var(--muted)', marginTop:2 }}>16 African languages · Captions · Cultural insights</p>
      </div>
      <div style={{ padding:'8px 16px', borderBottom:'1px solid var(--border)', display:'flex', gap:8, flexWrap:'wrap', flexShrink:0 }}>
        {LANGUAGES.slice(0,10).map(l => <span key={l.code} style={{ fontSize:11, color:'var(--muted)' }}>{l.flag} {l.name}</span>)}
        <span style={{ fontSize:11, color:'var(--sunset)' }}>+{LANGUAGES.length-10} more</span>
      </div>
      <div style={{ flex:1, overflowY:'auto', padding:16, display:'flex', flexDirection:'column', gap:12 }}>
        {messages.map((msg, i) => (
          <div key={i} style={{ display:'flex', gap:10, flexDirection: msg.role==='user' ? 'row-reverse' : 'row' }}>
            {msg.role === 'assistant' && <div style={{ width:30, height:30, borderRadius:'50%', flexShrink:0, background:'linear-gradient(135deg, var(--sunset), var(--flame))', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13 }}>✨</div>}
            <div style={{ maxWidth:'80%', padding:'10px 14px', borderRadius:16, fontSize:13, lineHeight:1.6, whiteSpace:'pre-wrap', background: msg.role==='user' ? 'linear-gradient(135deg, var(--flame), #a83220)' : 'var(--card)', color: msg.role==='user' ? 'white' : 'var(--text)', border: msg.role==='user' ? 'none' : '1px solid var(--border)', borderTopLeftRadius: msg.role==='assistant' ? 4 : 16, borderTopRightRadius: msg.role==='user' ? 4 : 16 }}>
              {msg.content}
            </div>
          </div>
        ))}
        {loading && (
          <div style={{ display:'flex', gap:10 }}>
            <div style={{ width:30, height:30, borderRadius:'50%', background:'linear-gradient(135deg, var(--sunset), var(--flame))', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13 }}>✨</div>
            <div style={{ background:'var(--card)', border:'1px solid var(--border)', borderRadius:16, borderTopLeftRadius:4, padding:'12px 16px', display:'flex', gap:6 }}>
              {[0,1,2].map(i => <span key={i} style={{ display:'inline-block', width:6, height:6, borderRadius:'50%', background:'var(--muted)', animation:'pulse 1.2s infinite', animationDelay: i*0.2+'s' }} />)}
            </div>
          </div>
        )}
        <div ref={bottomRef} />
      </div>
      <div style={{ display:'flex', flexWrap:'wrap', gap:6, padding:'8px 16px 12px', flexShrink:0 }}>
        {QUICK.map((p,i) => <button key={i} onClick={() => handleSend(p)} disabled={loading} style={{ padding:'6px 14px', borderRadius:20, fontSize:12, border:'1px solid rgba(232,168,56,0.3)', color:'var(--sunset)', background:'rgba(232,168,56,0.07)', cursor:'pointer' }}>{p.slice(0,35)}{p.length>35?'…':''}</button>)}
      </div>
      <div style={{ padding:'12px 16px', borderTop:'1px solid var(--border)', display:'flex', gap:8, flexShrink:0 }}>
        <input value={input} onChange={e => setInput(e.target.value)} onKeyDown={handleKey} disabled={loading} placeholder="Ask about African languages, culture, trends..." style={{ flex:1, padding:'10px 14px', borderRadius:22, background:'var(--card)', border:'1px solid var(--border)', color:'var(--text)', fontSize:13, fontFamily:'Space Grotesk,sans-serif' }} />
        <button onClick={() => handleSend()} disabled={loading || !input.trim()} style={{ width:40, height:40, borderRadius:'50%', background:'linear-gradient(135deg, var(--sunset), var(--flame))', border:'none', color:'white', fontSize:16, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>↗</button>
      </div>
    </div>
  );
}
